import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Guard de rutas solo-admin. Usa userRole del AuthContext (el contexto no
// expone currentUser). Espera a que la sesión esté resuelta para no redirigir
// en falso durante el arranque.
const AdminRoute = ({ children }) => {
  const { userRole, isAuthenticated, isAuthResolved } = useAuth();

  if (!isAuthResolved) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (userRole !== 'admin') return <Navigate to="/dashboard" replace />;

  return children;
};

export default AdminRoute;
